<template>
  <div class="subscription-item">
    <div class="subscription-item__title">{{ subscription.title }}</div>

    <el-table :data="subscription.user_membership_procedure" class="subscription-item__table zebra-table">
      <el-table-column prop="type" label="Тип услуги">
        <template slot-scope="scope">
          {{ scope.row.procedure.title }}
        </template>
      </el-table-column>
      <el-table-column prop="total" label="Всего посещений"></el-table-column>
      <el-table-column prop="accomplished" label="Пройдено посещений"></el-table-column>
    </el-table>

  </div>
</template>

<script>
export default {
  name: "SubscriptionItem",
  props: {
    visits: {},
    subscription: {
      require: true,
      default: () => []
    },
    serviceTypes: {
      require: true,
    },
  },
  data: () => {
    return {}
  },
  components: {},
  computed: {},
  methods: {
    findById(id) {
      return this.serviceTypes.find(item => item.id === id)
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/zebra-table.scss";

.subscription-item {
  margin-top: 24px;

  &__title {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;

    color: #111;
  }

  &__table {
    margin-top: 8px;

    /deep/ .cell {
      padding: 7px 16px;
      color: #111 !important;
    }
  }
}
</style>
